import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GoPlus } from "react-icons/go";
import ChatImg from "../../assets/images/Chat.png";
import NotificationImg from "../../assets/images/Bell.png";
import Search from "../../assets/images/search.png";
import HomeImg from "../../assets/images/HomeActive.png";
import Setting from "../../assets/images/Setting.png";
import { setPostReload } from "../../redux/slices/tempSlice";
import { resetNotificationsCount } from "../../redux/slices/notificationSlice";
import axios from "../Hooks/axios";
import styles from "./MobileFooter.module.scss";
import { IoSettingsOutline, IoRibbonOutline } from "react-icons/io5";
import { PiMagicWandFill } from "react-icons/pi";
import Notification from "../Small_Header/Notification";
import { toast } from "react-toastify";


function MobileFooter() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [LogoutPopup, setLogoutPopup] = useState(false);
    const { userId, user, token } = useSelector((state) => state.auth);
    const { users } = useSelector((state) => state.account);
    const [showNotification, setShowNotification] = useState(false);
    const { notificationsCount } = useSelector((state) => state.notification);

    const { pathname } = useLocation();

    return (
        <>
            {showNotification && (
                <div className={styles.notification}>
                    <Notification setShowNotification={setShowNotification} />
                </div>
            )}
            <div className={styles.navContainer}>
                <ul>
                    <li>
                        <div className={`${styles.ListItem} ${pathname.startsWith("/Home") && !showNotification ? styles.ActiveItem : ""}`}>
                            <Link 
                                to="/Home" 
                                title="Home" 
                                aria-label="Home" 
                                onClick={() => {
                                    setShowNotification(false);
                                    dispatch(setPostReload(true));
                                }}
                            >
                                <img src={HomeImg} alt="Home" />
                                {pathname.startsWith("/Home") && !showNotification && <span>Home</span>}
                            </Link>
                        </div>
                    </li>
                    <li>
                        <div className={`${styles.ListItem} ${pathname.startsWith("/Explore") && !showNotification ? styles.ActiveItem : ""}`}>
                            <Link 
                                to="/Explore" 
                                title="Explore" 
                                aria-label="Explore" 
                                onClick={() => setShowNotification(false)}
                            >
                                <img src={Search} alt="Explore" />
                                {pathname.startsWith("/Explore") && !showNotification && <span>Explore</span>}
                            </Link>
                        </div>
                    </li>
                    <li>
                        <div className={`${styles.ListItem} ${pathname.startsWith("/UploadPost2") && !showNotification ? styles.ActiveItem : ""}`}>
                            <Link 
                                to="/UploadPost2" 
                                title="Create" 
                                aria-label="Create Post" 
                                onClick={() => setShowNotification(false)}
                            >
                                <div className={styles.createIcon}>
                                    <GoPlus color="white" />
                                    {pathname.startsWith("/UploadPost2") && !showNotification && <span>Create</span>}
                                </div>
                            </Link>
                        </div>
                    </li>
                    <li>
                        <div className={`${styles.ListItem} ${pathname.startsWith("/Chat") && !showNotification ? styles.ActiveItem : ""}`}>
                            <Link 
                                to="/Chat" 
                                title="Chat" 
                                aria-label="Chat" 
                                onClick={() => {
                                    setShowNotification(false);
                                    dispatch(setPostReload(true));
                                }}
                            >
                                <img src={ChatImg} alt="Chat" />
                                {pathname.startsWith("/Chat") && !showNotification && <span>Chat</span>}
                            </Link>
                        </div>
                    </li>
                    <li>
                        <div className={`${styles.ListItem} ${pathname.startsWith("/AskFameoAI") && !showNotification ? styles.ActiveItem : ""}`}>
                            <Link 
                                to="/AskFameoAI" 
                                title="Ask Fameo AI" 
                                aria-label="Ask Fameo AI" 
                                onClick={() => setShowNotification(false)}
                            >
                                <PiMagicWandFill />
                                {pathname.startsWith("/AskFameoAI") && !showNotification && <span>Ask Fameo AI</span>}
                            </Link>
                        </div>
                    </li>
                    <li>
                        <div className={`${styles.ListItem} ${showNotification ? styles.ActiveItem : ""}`}>
                            <Link 
                                title="Notifications" 
                                aria-label="Notifications" 
                                onClick={() => {
                                    const nextState = !showNotification;
                                    setShowNotification(nextState);
                                    if (nextState) {
                                        dispatch(resetNotificationsCount());
                                        if (userId) axios.get(`/notification/seenAll/${userId}`).catch((e) => console.log(e));
                                    }
                                }}
                            >
                                {notificationsCount > 0 && <div className={styles.redDot}>{notificationsCount}</div>}
                                <img src={NotificationImg} alt="Notifications" />
                                {showNotification && <span>Notification</span>}
                            </Link>
                        </div>
                    </li>
                    <li>
                        <div className={`${styles.ListItem} ${pathname.startsWith("/Setting") && !showNotification ? styles.ActiveItem : ""}`}>
                            <Link 
                                to="/Setting" 
                                title="Settings" 
                                aria-label="Settings" 
                                onClick={() => {
                                    setShowNotification(false);
                                    dispatch(setPostReload(true));
                                }}
                            >
                                <img src={Setting} alt="Settings" />
                                {pathname.startsWith("/Setting") && !showNotification && <span>Settings</span>}
                            </Link>
                        </div>
                    </li>
                </ul>
            </div>
        </>
    );
}

export default MobileFooter;
